import React, { useCallback } from "react";
// Types
import { ChannelWithPosition, GridEvent, Position } from "../helpers/types";

interface useGridCellItemProps {
  onItemDrop?: GridEvent;
}

export function useGridExternalDnD({ onItemDrop }: useGridCellItemProps = {}) {
  const dropAreaRef = React.useRef(null);
  const [isDragOver, setIsDragOver] = React.useState(false);
  const handleDrop = useCallback(
    (
        item: {
          position: Position;
          channel: ChannelWithPosition;
        },
        index: number
      ) =>
      (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (dropAreaRef.current) {
          setIsDragOver(false);

          const droppedItemId = e.dataTransfer.getData("text/plain");
          const droppedItem = document.getElementById(droppedItemId);

          if (droppedItem) {
            // Loop through all attributes
            const attributes = droppedItem.attributes;
            const dataAttributes = {} as Record<string, string>;

            for (let i = 0; i < attributes.length; i++) {
              const attribute = attributes[i];
              if (attribute.name.startsWith("data-")) {
                dataAttributes[attribute.name.replace("data-", "")] =
                  attribute.value;
              }
            }

            // Call the onDrop callback with the dropped item, attributes, and position
            onItemDrop?.(item, index, dataAttributes)();
          }
        }
      },

    [onItemDrop]
  );

  const handleDragEnter = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    if (e) {
      e.preventDefault();
      if (dropAreaRef.current) {
        setIsDragOver(true);
      }
    }
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (dropAreaRef.current) {
      setIsDragOver(false);
    }
  }, []);

  return {
    isDragOver,
    dropAreaRef,
    onDrop: handleDrop,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
  };
}
